import {
	EventType,
	MessageType,
	IChatEventUserInfoMessage,
	IChatMessagesOut,
} from '@enuan/chat__utils';
import { useCallback, useRef } from 'react';
import { useSendMessage } from './messages.hooks';
import { useLogError } from '../../components/ErrorBoundary/useLogError';

export const useUpdateParams = () => {
	const sendMessage = useSendMessage();
	const prevParams = useRef<Record<string, any>>(undefined);
	const logError = useLogError('useUpdateParams');

	const updateParams = useCallback(
		(params: Record<string, any> = {}) => {
			if (prevParams.current && params !== prevParams.current) {
				const newParams = Object.entries(params).reduce(
					(prev, [key, value]) => {
						if (value !== prevParams.current?.[key]) {
							return { ...prev, [key]: value };
						}
						return prev;
					},
					{},
				);

				const event: IChatMessagesOut<IChatEventUserInfoMessage> = {
					_type: MessageType.EVENT,
					_data: {
						name: EventType.USER_INFO,
						parameters: newParams,
					},
				};
				sendMessage(event, true).catch((error) =>
					logError('sendUserInfo', { error, payload: { event } }),
				);
			}
			prevParams.current = params;
		},
		[sendMessage, logError],
	);

	return updateParams;
};
